import { Component, OnInit } from '@angular/core';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { mywalletloyaltycard } from '../../_services/mywallet/walletloyaltycard/mywallet.loyaltycard.service';
import { AuthService } from '../../_services/userservice/auth.service';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';
import { LoyaltyLoginComponent } from '../../user/loyalty-login/loyalty-login.component-Step1';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-walletloyaltycard',
  templateUrl: './walletloyaltycard.component.html',
  styleUrls: ['./walletloyaltycard.component.css'],
  providers: [AlertService, mywalletloyaltycard, AuthService]
})
export class WalletloyaltycardComponent implements OnInit {
  loyaltyCardFrontImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  loyaltyCardBackImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  constructor(
    private usermodel: usercommonattribute, //For getting user detail from profile
    private loyaltycardserv: mywalletloyaltycard,
    public modal: Modal,
    public utilServ: utilityService,
    public domSanitizer: DomSanitizer,
    private alertService: AlertService,
    private translate: TranslateService
  ) {}
  ngOnInit() {
    // this.loyaltyCardFrontImage =  AppSettings.imagefolder + 'noimage.png';
    this.getlolaltycardiage();
  }
  openLoyaltyCardLogin() {
    const modalData: any = {};
    modalData.isLoggedIn = true;
    this.modal.open(LoyaltyLoginComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  getlolaltycardiage() {
    this.utilServ.busy = this.loyaltycardserv.getloyaltycardlistservice().subscribe(
      data => {
        const resJSON = data;
        if (resJSON.Envelope.Body.LoyaltyCardResponse.StatusCode == 20001) {
          return false;
        }
        if (resJSON.Envelope.Body.LoyaltyCardResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          this.loyaltyCardFrontImage = '';
          if (
            this.usermodel.IsBeingLinked == true ||
            this.usermodel.IsBeingLinked.toString() == 'true' ||
            this.utilServ.getObjectText(resJSON.Envelope.Body.LoyaltyCardResponse.LoyaltyCardFrontImagePath) != ''
          ) {
            // Get Image
            // this.loyaltyCardFrontImage = AppSettings.baseImageURL + this.utilServ.getObjectText(data.Envelope.Body.LoyaltyCardResponse.LoyaltyCardFrontImagePath);
            // this.loyaltyCardBackImage = AppSettings.baseImageURL + this.utilServ.getObjectText(data.Envelope.Body.LoyaltyCardResponse.LoyaltyCardRearImagePath);

            this.utilServ.busy = this.utilServ.getIceImage(this.utilServ.getObjectText(data.Envelope.Body.LoyaltyCardResponse.LoyaltyCardFrontImagePath)).subscribe(res => {
              const urlCreator = window.URL;
              this.loyaltyCardFrontImage = urlCreator.createObjectURL(res);
            });
            this.utilServ.busy = this.utilServ.getIceImage(this.utilServ.getObjectText(data.Envelope.Body.LoyaltyCardResponse.LoyaltyCardRearImagePath)).subscribe(res => {
              const urlCreator = window.URL;
              this.loyaltyCardBackImage = urlCreator.createObjectURL(res);
            });
          } else if (this.usermodel.IsBeingLinked == false || this.usermodel.IsBeingLinked == 'false') {
            // Scanner
            this.openLoyaltyCardLogin();
          }
        } else {
        }
      },
      error => console.log('Unable to get loyalty Card Image' + error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/walletloyaltycard/walletloyaltycard.component.ts